// extracted by mini-css-extract-plugin
export default {"active":"styles-module__active__src-labstep-web-components-ResourceLocation-Label-Link-_nIzBX"};